<div class="wrapper main-content" style="overflow-y: auto; height: 100vh">
  <!--topbar -->
  <div class="row bg-dark">
    <div class="container-fluid">
      <div class="row d-flex justify-content-between align-items-center px-3">
        <!-- Left Side: Booking Assistance -->
        <div>
          <div class="text-left mt-1">
            <strong class="responsive-text-medium" style="color: rgb(255, 255, 255)">
              For Booking Assistance,
            </strong>
          </div>
          <div class="text-right mt-1">
            <strong class="responsive-text-medium" style="color: rgb(194, 214, 155)">
              +91 9607095588
            </strong>
          </div>
          <div class="text-right mt-1">
            <strong class="responsive-text-medium" style="color: rgb(194, 214, 155)">
              +91 2026926230
            </strong>
          </div>
        </div>
        <!-- Left Side: Booking Assistance -->

        <!-- Middle: Nisargopchar Ashram with Logo-->
        <div class="row p-1">
          <img class="newLogo" src="\assets\img\New Logo - Transperent.png" width="80" height="80" alt="" />
          <div class="ml-2 mt-2">
            <strong class="responsive-text" style="color: rgb(119, 197, 236)">
              NISARGOPCHAR </strong><br />
            <div class="text-right mt-1">
              <strong class="responsive-text-small" style="color: rgb(194, 214, 155)">
                ASHRAM
              </strong>
            </div>
            <div class="text-right">
              <strong class="responsive-text-very-small" style="color: rgb(255, 255, 255)">
                (Nisargopchar Gramsudhar Trust)
              </strong>
            </div>
          </div>
        </div>
        <!-- Middle: Nisargopchar Ashram with Logo-->

        <!-- Right Side: Links and Booking Button *ngIf="globals.UserName == ''"-->
        <div class="d-flex mr-2 ml-3" style="font-size: 1.5em">
          <div class="mr-3">
            <a class="row" style="color: rgb(119, 197, 236)" title="Naturopathy & holistic healing schedule"
              routerLink="/session/dincharya">
              <i class="fa fa-calendar mr-2 mt-1"></i>
              <p class="responsive-text-medium mt-1">Day Schedule</p>
            </a>
            <a class="row ttm-topbar-btn mt-1" style="color: rgb(194, 214, 155)" *ngIf="globals.UserName == ''"
              title="Schedule a Visit For Healing , Swasthya Seva, Chikitsa Niyojan"
              routerLink="/session/booking/booking">
              <i class="fa-solid fa-bed mr-2 mt-1"></i>
              <p class="responsive-text-medium mt-1">Book Now</p>
            </a>
          </div>

          <div class="secondary-menu ms-auto text-black mr-2" *ngIf="globals.UserName != ''">
            <ul class="nav secondary-menu-list d-flex align-items-center" data-dropdown-in="fadeIn"
              data-dropdown-out="fadeOut">
              <li class="dropdown">
                <a class="relative rounded-bg" href="javascript:void(0)" id="navbarDropdownMenuLin"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <img class="rounded-circle" src="assets/img/user-3.jpg" alt="User-image" width="55" height="55"
                    title="ClientName" />
                  <div class="online-caret bg-primary circle">
                    <i class="fa fa-caret-down"></i>
                  </div>
                </a>
                <!-- routerLink="/session/home" -->
                <div class="dropdown-menu rounded-0 dropdown-menu-right p-0" aria-labelledby="navbarDropdownMenuLin">
                  <a class="dropdown-item d-flex pb-2" (click)="goHome()">
                    <div class="icon-area align-self-start">
                      <i class="fa fa-home text-white"></i>
                    </div>
                    <div class="icon-msg mx-2">
                      <span class="align-self-start d-block">{{'Home' | translate}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex pt-3" *ngIf="globals.UserName != ''">
                    <div class="icon-area align-self-start">
                      <i class="fa fa-user"></i>
                    </div>
                    <div class="icon-msg mx-2">
                      <span class="align-self-start d-block">{{globals.UserName | translate}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex pb-2 d-none" *ngIf="globals.UserName != ''"
                    routerLink="/session/booking-login/UserDetails">
                    <!-- (click)="GetUserUpdateDetails();" -->
                    <div class="icon-area align-self-start">
                      <i class="fa fa-edit"></i>
                    </div>
                    <div class="icon-msg mx-2">
                      <span class="align-self-start d-block">{{'Update Profile' | translate}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex pb-2" *ngIf="globals.UserName != ''"
                    routerLink="/session/change-password">
                    <div class="icon-area align-self-start">
                      <i class="fa fa-cog"></i>
                    </div>
                    <div class="icon-msg mx-2">
                      <span class="align-self-start d-block">{{'Update Password' | translate}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex pb-2" *ngIf="globals.UserName != ''" (click)="LogOut()">
                    <div class="icon-area align-self-start">
                      <i class="fa fa-power-off"></i>
                    </div>
                    <div class="icon-msg mx-2">
                      <span class="align-self-start d-block">{{'Logout' | translate}}</span>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- Right Side: Links and Booking Button -->
      </div>
    </div>
  </div>

  <!--MENU BAR-->
  <header class="navbar-container">
    <!--Social media Icons-->
    <div class="col-md-2 social-icons mr-2 ml-3">
      <!-- <a style="font-size: 1.5em; color: rgb(119, 197, 236);">
      <i class="fa fa fa-language"></i>
      </a> -->

      <div class="dropdown">
        <a style="font-size: 1.5em; color: rgb(119, 197, 236)" id="languageDropdown" role="button"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa fa-language"></i>
        </a>
        <ul class="dropdown-menu" aria-labelledby="languageDropdown">
          <li><a class="dropdown-item">English</a></li>
          <li><a class="dropdown-item">Hindi</a></li>
          <li><a class="dropdown-item">Marathi</a></li>
        </ul>
      </div>

      <a style="font-size: 1.5em; color: rgb(194, 214, 155)" href="mailto:enquiry@nisargopacharashram.org"
        target="_blank">
        <i class="fa fa-envelope-o"></i>
      </a>
      <a style="font-size: 1.5em; color: rgb(194, 214, 155)" href="https://www.facebook.com/nisargopcharashram"
        target="_blank">
        <i class="fa fa-facebook"></i>
      </a>
      <a style="font-size: 1.5em; color: rgb(194, 214, 155)" href="https://twitter.com/nisargopcharash" target="_blank">
        <i class="fa fa-twitter"></i>
      </a>
      <a style="font-size: 1.5em; color: rgb(194, 214, 155)" href="#" target="_blank">
        <i class="fa fa-youtube"></i>
      </a>
      <a style="font-size: 1.5em; color: rgb(194, 214, 155)"
        href="https://www.instagram.com/nisargopchar.ashram?igsh=MTJvNHVvY2kzZjJkNQ==" target="_blank">
        <i class="fa fa-instagram"></i>
      </a>
    </div>
    <nav class="nav-links navbar-expand-lg mt-1 ttm-bgcolor-whiteecolor">
      <ul class="navbar-nav ml-auto text-expand-lg">
        <li class="nav-item active mr-2">
          <!-- routerLink="/session/home" -->
          <a class="nav-link" href="#" style="font-family: Calibri; font-size: 1.16em; color: #DC143C;"
            (click)="goHome()">
            <strong> HOME </strong>
          </a>
        </li>
        <li class="nav-item dropdown active mr-2">
          <a class="nav-link dropdown-toggle" style="font-family: Calibri; font-size: 1.16em; color: #DC143C;" href="#"
            id="navbarDropdown1" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <strong>ABOUT US </strong>
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown1">
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/history">OUR INSPIRATION</a>
            <!-- <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/objectofthetrust">OBJECTIVE</a> -->
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/trustees">TRUSTEES</a>
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/doctors">OUR HEALING TEAM</a>
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/aday-at-ashram">A DAY AT ASHRAM</a>
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/things-to-carry">THINGS TO CARRY</a>
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/rules">RULES AND REGULATIONS</a>
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/location">LOCATION</a>
            <!-- <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/nature-cure">NATURE CURE</a> -->
            <!-- <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/testimonials">TESTIMONIALS</a>
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/about/workshops">WORKSHOPS/SEMINARS</a> -->
          </div>
        </li>
        <li class="nav-item dropdown active mr-2">
          <a class="nav-link dropdown-toggle" href="#" style="font-family: Calibri; font-size: 1.16em; color: #DC143C;"
            id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <strong> THERAPIES </strong>
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/therapies/treatmentphilosopy">TREATMENT PHILOSOPY</a>
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/therapies/treatments">CONDITIONS TREATED</a>
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/therapies/conditionsnottreatedoradmitted">CONDITIONS NOT TREATED/ADMITTED</a>
          </div>
        </li>
        <li class="nav-item dropdown active mr-2">
          <!-- <a class="nav-link dropdown-toggle" style="font-family: Calibri; font-size: 1.16em" href="#"
            id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <strong> FACILITIES </strong>
          </a> -->

          <a class="nav-link dropdown-toggle" style="font-family: Calibri; font-size: 1.16em; color: #DC143C;" href="#"
            id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <strong> FACILITIES </strong>
          </a>


          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/facilities/isfacilitie">ACCOMMODATION</a>
            <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/facilities/isservices">SERVICES</a>
            <!-- <a class="dropdown-item" style="font-family: Calibri; font-size: 1.16em"
              routerLink="/session/facilities/isonlineyoga">ONLINE YOGA</a> -->
          </div>
        </li>
        <li class="nav-item active mr-2">
          <a class="nav-link" style="font-family: Calibri; font-size: 1.16em; color: #DC143C;"
            routerLink="/session/tariff/tariff">
            <strong> TARIFF </strong>
          </a>
        </li>
        <li class="nav-item active mr-2">
          <a class="nav-link" style="font-family: Calibri; font-size: 1.16em; color: #DC143C;"
            routerLink="/session/gallery">
            <strong> GALLERY </strong>
          </a>
        </li>
        <!-- <li class="nav-item active">
          <a class="nav-link" style="font-family: Calibri; font-size: 1.16em;" routerLink="/session/donate">
            <strong>
              DONATION
            </strong>
          </a>
        </li> -->
      </ul>
    </nav>
    <!-- MENU BAR-->

    <div class="col-md-2 d-flex justify-content-center align-items-center mt-1">
      <a href="assets/pdf/Booking_Guide.pdf" target="_blank"
        style="font-family: Calibri; font-size: 1.16em; color: #000000;margin-left: 20px;">
        📄 Booking Guide
      </a>
    </div>

  </header>

  <!-- <label class="message alert ticker-banner" *ngIf="isRateChange">
    <span class="ticker-label">📢 NOTICE</span>
    <div class="ticker-wrapper">
      <div class="ticker-track">
        <span class="ticker-item">
          🌿 Please note: Room tariffs will be revised from 15 August 2026. Charges may vary based on your stay dates.
          &nbsp;
          <a href="\assets\img\NCA_Tafiff_15-08-26.jpeg" target="_blank" class="ticker-link">
            ➤ Click here to view updated rates
          </a>
          &nbsp;&nbsp;&nbsp;&nbsp;❋&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span class="ticker-item">
          🌿 Please note: Room tariffs will be revised from 15 August 2026. Charges may vary based on your stay dates.
          &nbsp;
          <a href="\assets\img\NCA_Tafiff_15-08-26.jpeg" target="_blank" class="ticker-link">
            ➤ Click here to view updated rates
          </a>
          &nbsp;&nbsp;&nbsp;&nbsp;❋&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </div>
    </div>
  </label> -->

  <div class="content">
    <router-outlet></router-outlet>
  </div>

  <div class="footer-container bg-dark container-fluid mr-3 mt-2">
    <div class="container">
      <div class="">
        <div class="col-md-10 d-flex justify-content-between pl-0">
          <div class="d-flex align-items-start mt-2">
            <h1 class="text-white">Quick Links</h1>
          </div>
          <div class="d-flex align-items-start mt-2 mr-5">
            <h1 class="text-white">Contact Info</h1>
          </div>
        </div>
        <div class="row ml-1">
          <div class="col-lg">

            <div class="row text-white text-left">
              <ul>
                <li>
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/about/history">Our Inspiration</a>
                </li>
                <!-- <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/about/objectofthetrust">Objectives Of The Trust</a>
                </li> -->
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/about/trustees">Trustees</a>
                </li>
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/about/doctors">Doctors</a>
                </li>
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/about/aday-at-ashram">A day at Ashram</a>
                </li>
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/about/things-to-carry">Things to Carry</a>
                </li>
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/about/rules">Rules and Regulations</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg">
            <div class="row">
              <ul>
                <li>
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/tariff/cancelationpolicy">Cancellation & Booking Modification Policy</a>
                </li>
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/therapies/treatmentphilosopy">Treatment Philosophy</a>
                </li>
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/therapies/treatments">Treatments</a>
                </li>
                <!-- <li class="mt-3">
                <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                  routerLink="/session/about/workshops">Workshops / Seminars</a>
              </li> -->
                <!-- <li class="mt-3">
                <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                  routerLink="/session/about/nature-cure">Nature Cure</a>
              </li> -->
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/tariff/tariff">
                    Tariff</a>
                </li>
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white"
                    style="font-family: Calibri; font-size: 1.16em">Blog</a>
                </li>
                <!-- <li class="mt-3">
                  <a class="d-flex justify-content-start text-white"
                    style="font-family: Calibri; font-size: 1.16em">Contact</a>
                </li> -->
                <li class="mt-3">
                  <a class="d-flex justify-content-start text-white" style="font-family: Calibri; font-size: 1.16em"
                    routerLink="/session/about/location">Location</a>
                </li>
                <!-- <li class="mt-3"><a class="d-flex justify-content-start text-white"
                  style="font-family: Calibri; font-size: 1.16em;">Donation</a></li> -->
              </ul>
            </div>
          </div>
          <div class="col-lg">

            <div>
              <div class="text-white text-left line_space">
                <p class="text-white" style="font-family: Calibri; font-size: 1.16em">
                  Nisargopachar Ashram
                  <br />Nisargopachar Gramsudhar Trust <br />Urulikanchan, Pune
                  412 202, <br />Maharashtra, India
                </p>
                <p class="text-white d-flex">
                  <span style="
                    min-width: 70px;
                    font-family: Calibri;
                    font-size: 1.16em;
                  ">Phone :</span>
                  <span>
                    <a href="tel:+912026926298" style="font-family: Calibri; font-size: 1.16em"
                      class="text-white d-block">+91 20 2692 6298</a>
                    <a href="tel:+912026926230" style="font-family: Calibri; font-size: 1.16em"
                      class="text-white d-block">+91 20 2692 6230</a>
                    <!-- <a href="tel:+912026926250" style="font-family: Calibri; font-size: 1.16em"
                      class="text-white d-block">+91 20 2692 6250</a> -->
                  </span>
                </p>
                <p class="text-white d-block" style="font-family: Calibri; font-size: 1.16em">
                  Mobile Number :
                  <a href="tel:9607095588" style="font-family: Calibri" class="text-white">9607095588</a>
                </p>
                <p class="text-white d-block" style="font-family: Calibri; font-size: 1.16em">
                  E-Mail :
                  <a href="mailto:enquiry@nisargopacharashram.org" style="font-family: Calibri" class="text-white"
                    target="_blank">
                    enquiry<span>&#64;</span>nisargopacharashram.org
                  </a>
                </p>
                <p class="text-white d-block" style="
                  font-family: Calibri;
                  font-size: 1.16em;
                  margin-bottom: 0px;
                ">
                  Website:
                  <a style="font-family: Calibri" class="text-white" target="_blank">
                    nisargopacharashram.org
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <hr style="background-color: white;" />
    <div class="footer ttm-textcolor-white footer-black-dark bg-dark mt-2" style="
        display: flex;
        justify-content: space-between;
        font-family: Calibri;
        font-size: 1.16em;
      ">
      <div class="col">
        © Copyright {{currentDate | date:'YYYY'}} Nisargopchar Ashram - All
        Rights Reserved.
      </div>
      <div class="col text-right">
        Designed & Developed by Carme Systems | Sitemap
      </div>
    </div>
  </div>
</div>